<div class="custom-select-option">
  <ng-select
    #select
    [formControl]="formControl"
    [compareWith]="props.compareWith ? props.compareWith : defaultOptions.props.compareWith"
    [formlyAttributes]="field"
    [ngClass]="props.inputClass"
    [attr.data-testing-id]="field.key"
    [placeholder]="field?.templateOptions?.placeholder ?? field?.props?.placeholder"
    [fixedPlaceholder]="true"
    (change)="makeBlur(select)"
    (close)="makeBlur(select)"
  >
    @if (selectOptions && selectOptions | formlySelectOptions : field | async; as opts) { @for (opt of opts; track opt)
    { @if (opt?.value !== '') {
    <ng-option [value]="opt.value" [disabled]="opt.disabled">
      {{ opt.label }}
    </ng-option>
    } } }
  </ng-select>
</div>
